export function SkeletonCard({ lines = 3, className = '' }) {
  return (
    <div className={`glass-card p-4 space-y-3 ${className}`}>
      <div className="skeleton h-4 w-3/4 rounded" />
      {Array.from({ length: lines - 1 }).map((_, i) => (
        <div key={i} className={`skeleton h-3 rounded ${i === lines - 2 ? 'w-1/2' : 'w-full'}`} />
      ))}
    </div>
  );
}

export function SkeletonTable({ rows = 5 }) {
  return (
    <div className="space-y-2">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex gap-4 px-4 py-3 border-b border-navy-border">
          <div className="skeleton h-4 w-16 rounded" />
          <div className="skeleton h-4 w-24 rounded" />
          <div className="skeleton h-4 flex-1 rounded" />
          <div className="skeleton h-4 w-20 rounded" />
          <div className="skeleton h-4 w-16 rounded" />
        </div>
      ))}
    </div>
  );
}

export function SkeletonStat() {
  return (
    <div className="glass-card p-5 space-y-2">
      <div className="skeleton h-3 w-20 rounded" />
      <div className="skeleton h-8 w-32 rounded" />
      <div className="skeleton h-2 w-full rounded" />
    </div>
  );
}
